<template>
    <div class="m-viewDialog" v-loading="loading">
        <div class="warp" >
            <iframe :src="pageUrl" frameborder="0" width="400px" height="400px" id="iframe" name="iframe"></iframe>
        </div>
        <div class="dialog-footer" slot="footer">
            <el-button @click="close" class="btnType btnCancel" >关闭</el-button>
            <el-button  v-clipboard:success="onCopy" v-clipboard:copy="copyUrl" class="btnType btnCancel">复制链接</el-button>
            <el-button @click="release" class="btnNew">发布</el-button>
        </div>
    </div>
</template>


<script>
import API from '@/fetch/api'

export default {
    props: ['url'],
    data(){
        return {
            m_iframe: null,
            loading: true
        }
    },
    mounted(){
        let vm = this;
        vm.m_iframe = document.getElementById("iframe");
        try{
            vm.m_iframe.onload = ()=>{
                vm.loading = false;
                // setTimeout(vm.setIframeHeight, 500);
            }
        }catch(e){
            vm.m_iframe.onreadystatechange = function(){
                if (vm.m_iframe.readyState == "complete"){ 
                    vm.loading = false;
                    // vm.setIframeHeight();
                }
            }
        }
    },
    computed: {
        pageUrl(){
            // 预览增加 preView 字段，预览时不需要操作按钮
            let urls = API.url().split(':');
            return `${urls[0]}:${urls[1]}/power/#${this.url}&preView=1`
        },
        copyUrl(){
            let urls = API.url().split(':');
            return `${urls[0]}:${urls[1]}/power/#${this.url}`
        }
    },
    methods: {
        setIframeHeight() {
            if(!this.m_iframe) return;
            if(!this.m_iframe.contentWindow.document) return;
            let bHeight = this.m_iframe.contentWindow.document.body.scrollHeight,
                dHeight = this.m_iframe.contentWindow.document.documentElement.scrollHeight,
                height = Math.max(bHeight, dHeight);
            this.m_iframe.height = height;
        },
        release(){
            this.$emit('ok');
        },
        close(){
            this.$emit('close');
        },
        onCopy(){
            this.$showAlert('复制成功', 'success');
        }
    }
}
</script>

<style lang="scss" scoped>
    .m-viewDialog{
        .warp{
            height: 400px;
            overflow-y: hidden;
            padding: 10px 20px;
            /deep/ .el-scrollbar__wrap{
                overflow-x: hidden;
            }
        }
        
    }
</style>
